import React, { useState } from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { LanguageDropdown } from './LanguageDropdown';
import { wrapIterator } from '../../../shared/helper/IterableIteratorWrapper';
import { Heading1Base, Heading2Base } from '../shared/Heading';
import { translationStore } from '../../stores/TranslationStore';
import { gameStore } from '../../stores/GameStore';
import { action } from 'mobx';
import { errorStore } from '../../stores/ErrorStore';
import { Overlay } from '../shared/PopupComponents';
const Table = styled.table.withConfig({
  displayName: "MakeshiftTranslationSystemDataDisplay__Table",
  componentId: "sc-1xyk19y-0"
})(["border-collapse:collapse;tr{border:1px solid lightgrey;}th,td{padding:5px 10px;}"]);
const TitleRow = styled.tr.withConfig({
  displayName: "MakeshiftTranslationSystemDataDisplay__TitleRow",
  componentId: "sc-1xyk19y-1"
})([""]);
const MakeshiftTranslationSystemCategoryDisplay = observer(({
  titleKey,
  category
}) => {
  const {
    t
  } = useTranslation();
  const removeTranslation = action(id => {
    category.delete(id);
  });
  return /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement(TitleRow, null, /*#__PURE__*/React.createElement("td", {
    colSpan: 3
  }, /*#__PURE__*/React.createElement(Heading2Base, null, t(titleKey)))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, t("translation.language_" + gameStore.languageKey)), /*#__PURE__*/React.createElement("td", null)), wrapIterator(category.translations.entries()).map(([id, translatedString]) => /*#__PURE__*/React.createElement("tr", {
    key: id
  }, /*#__PURE__*/React.createElement("td", null, id), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: translatedString.get(gameStore.languageKey, false),
    placeholder: translatedString.get(gameStore.languageKey, true),
    onChange: ({
      target
    }) => translatedString.set(gameStore.languageKey, target.value)
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("button", {
    onClick: () => removeTranslation(id)
  }, t("translation.makeshift_translation_system_remove")))))));
});
export const MakeshiftTranslationSystemDataDisplay = observer(() => {
  const {
    t
  } = useTranslation();
  const [baseLanguage, setBaseLanguage] = useState("de");
  const [addingInProgress, setAddingInProgress] = useState(false);
  const {
    tileTags,
    actionEditorTemplateTags,
    characterSkinVariantClasses,
    characterSkinVariantOptions,
    totalCount
  } = translationStore.makeshiftTranslationSystemData;

  const addMissing = async () => {
    try {
      setAddingInProgress(true);
      await translationStore.addMissingMakeshiftTranslationSystemEntries(baseLanguage);
    } catch (e) {
      errorStore.addErrorFromErrorObject(e);
    } finally {
      setAddingInProgress(false);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, addingInProgress && /*#__PURE__*/React.createElement(Overlay, null), /*#__PURE__*/React.createElement(Heading1Base, null, t("translation.makeshift_translation_system")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", null, t("translation.makeshift_translation_system_description", {
    buttonName: t("translation.makeshift_translation_system_add_missing")
  })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", null, t("translation.makeshift_translation_system_add_missing_base_language"), ": \xA0", /*#__PURE__*/React.createElement(LanguageDropdown, {
    value: baseLanguage,
    setValue: setBaseLanguage
  }), "\xA0", /*#__PURE__*/React.createElement("button", {
    onClick: addMissing
  }, t("translation.makeshift_translation_system_add_missing"))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("h2", null, t("translation.makeshift_translation_system_current_count")), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, t("translation.makeshift_translation_system_tile_tags"), ": ", tileTags.count), /*#__PURE__*/React.createElement("li", null, t("translation.makeshift_translation_system_action_editor_template_tags"), ": ", actionEditorTemplateTags.count), /*#__PURE__*/React.createElement("li", null, t("translation.makeshift_translation_system_character_skin_variant_classes"), ": ", characterSkinVariantClasses.count), /*#__PURE__*/React.createElement("li", null, t("translation.makeshift_translation_system_character_skin_variant_names"), ": ", characterSkinVariantOptions.count), /*#__PURE__*/React.createElement("li", null, t("translation.makeshift_translation_system_total_count"), ": ", totalCount)), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(MakeshiftTranslationSystemCategoryDisplay, {
    titleKey:
    /*t*/
    "translation.makeshift_translation_system_tile_tags",
    category: tileTags
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(MakeshiftTranslationSystemCategoryDisplay, {
    titleKey:
    /*t*/
    "translation.makeshift_translation_system_action_editor_template_tags",
    category: actionEditorTemplateTags
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(MakeshiftTranslationSystemCategoryDisplay, {
    titleKey:
    /*t*/
    "translation.makeshift_translation_system_character_skin_variant_classes",
    category: characterSkinVariantClasses
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(MakeshiftTranslationSystemCategoryDisplay, {
    titleKey:
    /*t*/
    "translation.makeshift_translation_system_character_skin_variant_names",
    category: characterSkinVariantOptions
  }));
});